import React from 'react'
import PhoneController from '../../components/common/controller/PhoneController'
import Button from '../../components/general/Button'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { enquiryValidationSchema } from '../../utils/validation'
import { axiosUnauthInstance } from '../../service/API'
import { setShowSuccessModal } from '../../redux/slice/commonSlice'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

const RegistrationCardForm = ({ name, developerPageURL = '', onSucess = undefined }) => {
    const dispatch = useDispatch();
    const { reset, control, register, handleSubmit, formState: { errors, isValid } } = useForm({
        mode: "onBlur",
        resolver: yupResolver(enquiryValidationSchema)
    });

    const onSubmit = async (data) => {
        const payload = {
            ...data,
            name : name,
            developer_page_url : developerPageURL
        }
        try {
            const response = await axiosUnauthInstance.post('/leads/', payload);
            if (response.status === 201) {
                toast.success('Thank you for your interest in our services. We will get back to you soon.');
                reset();
                dispatch(setShowSuccessModal(true));

                if (onSucess) onSucess();
            }
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="bg-[#292929] rounded-[10px] text-white py-[50px] px-[20px]">
            <h3 className="font-bold text-primary-color text-center text-[1.25rem]"> REGISTER TO ACCESS </h3>
            <h3 className="font-light text-center mb-[20px] text-[1.25rem]"> READY-TO-HIRE DEVS </h3>
            <div className='flex flex-col gap-[20px]'>

                <div>
                    <input {...register('email')} type="text" className='bg-transparent border border-white rounded-[5px] px-[20px] py-[10px] w-full my-[10px] h-[50px]' placeholder='Email' />
                    {
                        errors.email && (
                            <p className='text-red-500 text-[14px]'>{errors.email.message}</p>
                        )
                    }
                </div>
                <div className='lg:col-span-2'>
                    <PhoneController
                        name={"phone"}
                        control={control}
                        placeholder="Phone Number (Optional)"
                    />
                </div>

                <div>
                    <input {...register('website')} type="text" className='bg-transparent border border-white rounded-[5px] px-[20px] py-[10px] w-full my-[10px] h-[50px]' placeholder='Company Website' />
                    {
                        errors.website && (
                            <p className='text-red-500 text-[14px]'>{errors.website.message}</p>
                        )
                    }
                </div>
                <Button type='submit' disabled={!isValid} className="bg-primary-color text-black rounded-[5px] px-[20px] py-[10px] w-full h-[50px] text-[0.8rem] font-semibold">Submit Now</Button>
            </div>
        </form>
    )
}

export default RegistrationCardForm